import React, { useState, useEffect, useContext, useRef } from "react"
import ImageFromDrupal from "gatsby-theme-blank/src/components/Image/image-from-drupal"
import {
  backgroundContainer,
  backgroundContainerBis,
  backgroundContainerDetails,
  backgroundWrapper,
  backgroundInputWrapper,
  backgroundImageContainer,
  background,
  backgroundText,
  headerAccesDirect,
  notificationButton,
  searchButton,
  searchWrapper,
  searchOpened,
  headerDescription,
  headerCarousel,
  headerCarouselArrowLeft,
  headerCarouselArrowRight,
  headerDescriptionCarousel,
  headerDescriptionItem,
  editButton,
  pauseButton,
  carouselLightBoxOpener,
} from "./header-top.module.scss"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import SearchResults from "gatsby-theme-blank/src/components/search-results"
import ContenuLibre from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre"
import BandeauAlert from "../../../components/BandeauAlert/bandeau-alert"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import root from "window-or-global"
import PropTypes from "prop-types"
import {
  DirectAccess,
  CustomHeaderArrows,
  Container,
  SearchButton,
  NotificationButton,
} from "./header-top-styled"
import { NotificationContext } from "gatsby-theme-blank/src/components/notification-context"
import { AccesDirectContext } from "gatsby-theme-amaryllis/src/components/acces-direct-context"
import { useContenuLibre } from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre-query"
import { useAccesDirect } from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct-query"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import MultiCarousel from "react-multi-carousel"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"
import { LightBoxCarouselOpener } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"
import { ChangeSlide } from "gatsby-theme-blank/src/components/ChangeSlide/change-slide"

const HeaderTop = ({
  isIndex,
  isDetail,
  message,
  children,
  isGdd,
  inputHidden,
}) => {
  const [windowWidth, setWindowWidth] = useState(1000)
  const themeColors = useBuildData().theme_settings.palette
  const options = {
    buttons: {
      backgroundColor: themeColors.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
  }
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }
  useEffect(() => {
    let windowElement = null
    if (typeof window !== `undefined` && typeof document !== `undefined`) {
      windowElement = window
      setWindowWidth(windowElement.innerWidth)
      if (windowElement.innerWidth < 900) {
        const directAccessElement = document.querySelectorAll(
          "#acces-direct-responsive a"
        )
        directAccessElement.forEach((element) => {
          element.setAttribute("tabindex", isAccesDirectOpen ? "0" : "-1")
        })
      }
    }

    function handleResize() {
      setWindowWidth(windowElement.innerWidth)
    }

    windowElement.addEventListener("resize", handleResize)
    return () => windowElement.removeEventListener("resize", handleResize)
  }, [])
  const [isPaused, setIsPaused] = useState(false)
  let pauseIcon
  if (isPaused) {
    pauseIcon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24" />
          <path
            d="M9.82866499,18.2771971 L16.5693679,12.3976203 C16.7774696,12.2161036 16.7990211,11.9002555 16.6175044,11.6921539 C16.6029128,11.6754252 16.5872233,11.6596867 16.5705402,11.6450431 L9.82983723,5.72838979 C9.62230202,5.54622572 9.30638833,5.56679309 9.12422426,5.7743283 C9.04415337,5.86555116 9,5.98278612 9,6.10416552 L9,17.9003957 C9,18.1765381 9.22385763,18.4003957 9.5,18.4003957 C9.62084305,18.4003957 9.73759731,18.3566309 9.82866499,18.2771971 Z"
            fill="#000000"
          />
        </g>
      </svg>
    )
  } else {
    pauseIcon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24" />
          <path
            d="M8,6 L10,6 C10.5522847,6 11,6.44771525 11,7 L11,17 C11,17.5522847 10.5522847,18 10,18 L8,18 C7.44771525,18 7,17.5522847 7,17 L7,7 C7,6.44771525 7.44771525,6 8,6 Z M14,6 L16,6 C16.5522847,6 17,6.44771525 17,7 L17,17 C17,17.5522847 16.5522847,18 16,18 L14,18 C13.4477153,18 13,17.5522847 13,17 L13,7 C13,6.44771525 13.4477153,6 14,6 Z"
            fill="#000000"
          />
        </g>
      </svg>
    )
  }
  const buildInfos = useBuildData().site_settings
  const [results, setResults] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const { setIsOpen } = useContext(NotificationContext)
  const [isSearchOpened, setIsSearchOpened] = useState(false)
  const displayDirectAccess =
    useAccesDirect().allDirectLinkEntityDirectLinkEntity.edges.length > 0
  const { isAccesDirectOpen, setIsAccesDirectOpen } =
    useContext(AccesDirectContext)
  const [localNavigator, setLocalNavigator] = useState(null)
  const headerBanners = [
    buildInfos.header_banner?.fid,
    buildInfos.header_banner_1?.fid,
    buildInfos.header_banner_2?.fid,
  ].filter((element) => element)
  const lightBoxImages = []
  headerBanners.forEach((banner) => {
    lightBoxImages.push({
      type: "fromDrupal",
      alt: "Bannière " + buildInfos.website_name,
      id: banner,
    })
  })
  const headerBannerNumber = headerBanners.length
  let headerDescriptionNumber =
    useContenuLibre().allNodeContenuLibre.edges.filter(
      (element) =>
        element.node.relationships?.field_taxonomie_zone_libre?.name ===
        "zone_bandeau_accueil"
    )
  headerDescriptionNumber = headerDescriptionNumber.filter(
    (element) => element !== undefined
  )
  const carouselText = useRef()
  const carouselImage = useRef()
  const changeSlide = () => {
    ChangeSlide(carouselText)
  }
  ChangeSlide(carouselText)
  useEffect(() => {
    if (searchQuery && root.__LUNR__) {
      root.__LUNR__.__loaded.then((lunr) => {
        const refs = lunr.fr.index.search(
          `${searchQuery}^100 ${searchQuery}*^10 ${searchQuery}~2`
        )
        const posts = refs.map(({ ref }) => lunr.fr.store[ref])
        setResults(posts)
      })
    }
  }, [searchQuery])

  useEffect(() => {
    setLocalNavigator(navigator)
  }, [])
  let containerClass
  if (isIndex) {
    containerClass = backgroundContainer
  } else if (isDetail) {
    containerClass = backgroundContainerDetails
  } else {
    containerClass = backgroundContainerBis
  }
  return (
    <>
      {!isGdd && (
        <Container className={containerClass}>
          <>
            <div className={backgroundWrapper}>
              {isIndex && (
                <>
                  <button
                    className={pauseButton}
                    onClick={() => {
                      setIsPaused(!isPaused)
                    }}
                    aria-label={
                      isPaused
                        ? "Actionner le défilement automatique"
                        : "Arrêter le défilement automatique"
                    }
                  >
                    {pauseIcon}
                  </button>
                  <LightBoxCarouselOpener
                    images={lightBoxImages}
                    className={carouselLightBoxOpener}
                  />
                </>
              )}
              <EditButton
                link={"/admin/site-configuration"}
                addedClass={editButton}
              />
              {isIndex && (
                <>
                  <MultiCarousel
                    ref={carouselImage}
                    className={headerCarousel}
                    itemClass={backgroundImageContainer}
                    showDots={false}
                    responsive={responsive}
                    infinite={true}
                    arrows={
                      headerBannerNumber > 1 ||
                      headerDescriptionNumber.length > 1
                    }
                    autoPlay={
                      headerBannerNumber > 1 &&
                      typeof document !== `undefined` &&
                      !document.styleSheets[0].disabled &&
                      !isPaused
                    }
                    shouldResetAutoplay={headerBannerNumber > 1}
                    autoPlaySpeed={6000}
                    renderButtonGroupOutside={true}
                    customRightArrow={
                      <CustomRightArrow
                        isPlaying={headerBannerNumber > 1}
                        carouselImage={carouselImage}
                        carouselText={carouselText}
                      />
                    }
                    customLeftArrow={
                      <CustomLeftArrow
                        isPlaying={headerBannerNumber > 1}
                        carouselImage={carouselImage}
                        carouselText={carouselText}
                      />
                    }
                    beforeChange={(nextSlide, { currentSlide, onMove }) => {
                      if (headerDescriptionNumber.length > 1) {
                        if (nextSlide - currentSlide > 0) {
                          carouselText.current.next()
                        } else {
                          carouselText.current.previous()
                        }
                      }
                    }}
                  >
                    {buildInfos.header_banner?.fid && (
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <ImageFromDrupal
                            className={background}
                            alt={"Bannière " + buildInfos.website_name}
                            drupal_fid={buildInfos.header_banner.fid}
                            ariaHidden={true}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    )}
                    {buildInfos.header_banner_1?.fid && (
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <ImageFromDrupal
                            className={background}
                            alt={"Bannière " + buildInfos.website_name}
                            drupal_fid={buildInfos.header_banner_1.fid}
                            ariaHidden={true}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    )}
                    {buildInfos.header_banner_2?.fid && (
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <ImageFromDrupal
                            className={background}
                            alt={"Bannière " + buildInfos.website_name}
                            drupal_fid={buildInfos.header_banner_2.fid}
                            ariaHidden={true}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    )}
                  </MultiCarousel>
                  {headerDescriptionNumber.length > 0 && (
                    <div className={headerDescription}>
                      <MultiCarousel
                        ref={carouselText}
                        className={headerDescriptionCarousel}
                        showDots={false}
                        responsive={responsive}
                        swipeable={headerDescriptionNumber.length > 1}
                        draggable={headerDescriptionNumber.length > 1}
                        autoPlay={
                          headerBannerNumber <= 1 &&
                          headerDescriptionNumber.length > 1 &&
                          typeof document !== `undefined` &&
                          !document.styleSheets[0].disabled
                        }
                        shouldResetAutoplay={
                          headerBannerNumber <= 1 &&
                          headerDescriptionNumber.length > 1
                        }
                        autoPlaySpeed={6000}
                        infinite={true}
                        arrows={false}
                        renderButtonGroupOutside={true}
                        afterChange={changeSlide}
                      >
                        {headerDescriptionNumber
                          .reverse()
                          .map((value, index) => {
                            return (
                              <div
                                className={headerDescriptionItem}
                                key={index}
                              >
                                <EditButton
                                  addedClass={editButton}
                                  link={
                                    "/node/" +
                                    value?.node.drupal_internal__nid +
                                    "/edit"
                                  }
                                />
                                <ContenuLibre
                                  isIndex={true}
                                  zoneTaxoLibre={
                                    value?.node.relationships
                                      .field_taxonomie_zone_libre.name
                                  }
                                  index={index}
                                  bannerItem={value}
                                />
                              </div>
                            )
                          })}
                      </MultiCarousel>
                    </div>
                  )}
                </>
              )}
              {message && (
                <div className={backgroundText}>
                  <div>
                    <EditButton
                      link={"/admin/site-configuration"}
                      addedClass={editButton}
                    />
                    <h1>{message}</h1>
                  </div>
                </div>
              )}
              <div className={backgroundInputWrapper}>
                {inputHidden ? null : (
                  <>
                    {buildInfos.webpush_enabled &&
                    localNavigator?.serviceWorker ? (
                      <>
                        <NotificationButton
                          aria-label="Gestion des notifications"
                          className={notificationButton}
                          onClick={() => setIsOpen(true)}
                        >
                          <Icon icon="bell" size={16}></Icon>
                        </NotificationButton>
                      </>
                    ) : null}
                  </>
                )}
                <BandeauAlert alertContent={buildInfos.alert_message.value} />
              </div>
              {inputHidden ? null : (
                <div
                  className={
                    searchWrapper + " " + (isSearchOpened ? searchOpened : "")
                  }
                >
                  <SearchButton
                    aria-label="Recherche"
                    className={searchButton}
                    onClick={() => setIsSearchOpened(!isSearchOpened)}
                  >
                    <Icon icon="search" size={24}></Icon>
                  </SearchButton>
                  <input
                    type="search"
                    id="search-input"
                    name="keywords"
                    onChange={(element) => setSearchQuery(element.target.value)}
                    value={searchQuery}
                    placeholder="Rechercher..."
                    aria-label="Recherche"
                    aria-autocomplete="list"
                    aria-controls="list-result"
                    aria-expanded={searchQuery !== ""}
                    title={"Recherche"}
                    role="search"
                  />
                </div>
              )}
              {isIndex && displayDirectAccess && (
                <div className={headerAccesDirect}>
                  <DirectAccess
                    id={"open-acces-direct"}
                    href={"#acces-direct"}
                    onClick={(event) => {
                      if (event.detail === 0) {
                        // Ignorer les événements déclenchés par le clavier
                        return
                      }
                      if (typeof document !== `undefined`) {
                        const directAccessElement = document.querySelectorAll(
                          "#acces-direct-responsive a"
                        )
                        directAccessElement.forEach((element) => {
                          element.setAttribute("tabindex", "0")
                        })
                      }
                      setIsAccesDirectOpen(!isAccesDirectOpen)
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        setIsAccesDirectOpen(!isAccesDirectOpen)
                        if (typeof document !== `undefined`) {
                          const directAccessElement = document.querySelectorAll(
                            "#acces-direct-responsive a"
                          )
                          directAccessElement.forEach((element) => {
                            element.setAttribute("tabindex", "0")
                          })
                        }
                        setIsAccesDirectOpen(!isAccesDirectOpen)
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    {...(windowWidth < 900
                      ? { "aria-expanded": isAccesDirectOpen }
                      : null)}
                  >
                    Accès direct
                    <svg width="18px" height="18px" viewBox="0 0 24 24">
                      <g stroke="none" fill="none">
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M8.2928955,3.20710089 C7.90237121,2.8165766 7.90237121,2.18341162 8.2928955,1.79288733 C8.6834198,1.40236304 9.31658478,1.40236304 9.70710907,1.79288733 L15.7071091,7.79288733 C16.085688,8.17146626 16.0989336,8.7810527 15.7371564,9.17571874 L10.2371564,15.1757187 C9.86396402,15.5828377 9.23139665,15.6103407 8.82427766,15.2371482 C8.41715867,14.8639558 8.38965574,14.2313885 8.76284815,13.8242695 L13.6158645,8.53006986 L8.2928955,3.20710089 Z"
                          fill="#000000"
                          transform="translate(12.000003, 8.499997) scale(-1, -1) rotate(-90.000000) translate(-12.000003, -8.499997) "
                        />
                        <path
                          d="M6.70710678,19.2071045 C6.31658249,19.5976288 5.68341751,19.5976288 5.29289322,19.2071045 C4.90236893,18.8165802 4.90236893,18.1834152 5.29289322,17.7928909 L11.2928932,11.7928909 C11.6714722,11.414312 12.2810586,11.4010664 12.6757246,11.7628436 L18.6757246,17.2628436 C19.0828436,17.636036 19.1103465,18.2686034 18.7371541,18.6757223 C18.3639617,19.0828413 17.7313944,19.1103443 17.3242754,18.7371519 L12.0300757,13.8841355 L6.70710678,19.2071045 Z"
                          fill="#000000"
                          transform="translate(12.000003, 15.499997) scale(-1, -1) rotate(-360.000000) translate(-12.000003, -15.499997) "
                        />
                      </g>
                    </svg>
                  </DirectAccess>
                </div>
              )}
            </div>
          </>
        </Container>
      )}
      {searchQuery !== "" && (
        <SearchResults query={searchQuery} resultats={results} />
      )}
      {searchQuery === "" && (
        <div>
          <main role="main" id="main">
            {children}
          </main>
        </div>
      )}
    </>
  )
}
const CustomRightArrow = ({ isPlaying, carouselImage, carouselText }) => {
  return (
    <CustomHeaderArrows
      className={headerCarouselArrowRight}
      onClick={() =>
        isPlaying ? carouselImage.current.next() : carouselText.current.next()
      }
      title="Suivant"
    >
      <span aria-hidden="true"></span>
    </CustomHeaderArrows>
  )
}
const CustomLeftArrow = ({ isPlaying, carouselImage, carouselText }) => {
  return (
    <CustomHeaderArrows
      className={headerCarouselArrowLeft}
      onClick={() =>
        isPlaying
          ? carouselImage.current.previous()
          : carouselText.current.previous()
      }
      title="Précédent"
    >
      <span aria-hidden="true"></span>
    </CustomHeaderArrows>
  )
}
//-----------------------Prop-Types---------------------------//

HeaderTop.propTypes = {
  children: PropTypes.node.isRequired,
  isIndex: PropTypes.bool,
  isDetail: PropTypes.bool,
  message: PropTypes.string,
  isGdd: PropTypes.bool,
  inputHidden: PropTypes.bool,
}

CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
  carouselImage: PropTypes.object,
  carouselText: PropTypes.object,
}

CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
  carouselImage: PropTypes.object,
  carouselText: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default HeaderTop
